import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-icon_minus_circle",
  "use": "icon-icon_minus_circle-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_minus_circle\"><defs><style></style></defs><path d=\"M491.52 71.68a440.32 440.32 0 0 1 311.296 751.616 440.32 440.32 0 0 1-622.592-622.592A437.453 437.453 0 0 1 491.52 71.68m0-51.2a491.52 491.52 0 1 0 348.16 143.36A489.882 489.882 0 0 0 491.52 20.48z\" /><path d=\"M781.107 537.6H201.933a25.6 25.6 0 0 1 0-51.2h579.174a25.6 25.6 0 0 1 0 51.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol